export default __webpack_public_path__ + "static/media/shutterstock_1230016774.0ec3e4e5.png";